export default __webpack_public_path__ + "static/media/networth.b077ea0e.svg";